import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
const DMI = React.lazy(() => import("views/DMI"));
const MuthootFinance = React.lazy(() => import("views/MuthootFinance"));
const HdfcPersonalLoans = React.lazy(() => import("views/HdfcPersonalLoans"));
const ZetMagnet = React.lazy(() => import("views/ZetMagnet"));
const FiftyFin = React.lazy(() => import("views/FiftyFin"));
const HdfcCredila = React.lazy(() => import("views/HdfcCredila"));
const JupiterCards = React.lazy(() => import("views/JupiterCards"));
const HsbcPl = React.lazy(() => import("views/HsbcPl"));
const LICAxisCrards = React.lazy(() => import("views/LICAxisCards"));
const IncredPl = React.lazy(() => import("views/IncredPl"));
const Profusion = React.lazy(() => import("views/Profusion"));
const Hlbt = React.lazy(() => import("views/Hlbt"));
const FibeBank = React.lazy(() => import("views/FibeBank"));
const SmartWorld = React.lazy(() => import("views/SmartWorld"));
const Propelld = React.lazy(() => import("views/Propelld"));
const DbsGold = React.lazy(() => import("views/DbsGold"));
const Kissht = React.lazy(() => import("views/Kissht"));
const SbiStaticPage = React.lazy(() => import("views/SbiStaticPage"));
const AxisCredit = React.lazy(() => import("views/AxisCredit"));
const SmartCoin = React.lazy(() => import("views/SmartCoin"));
const PreferStatic = React.lazy(() => import("views/PreferStatic"));
const AxisBankNew = React.lazy(() => import("views/AxisBankNew"));
const Privo = React.lazy(() => import("views/Privo"));
const Au = React.lazy(() => import("views/Au"));
const AxisBank = React.lazy(() => import("views/AxisBank"));
const AxisCC = React.lazy(() => import("views/AxisCC"));
const BajajRbl = React.lazy(() => import("views/BajajRbl"));
const CashKaro = React.lazy(() => import("views/CashKaro"));
const Cashe = React.lazy(() => import("views/Cashe"));
const CasheEarlySalary = React.lazy(() => import("views/CasheEarlySalary"));
const CitiBank = React.lazy(() => import("views/CitiBank"));
const CreditCard = React.lazy(() => import("views/CreditCard"));
const CreditVidya = React.lazy(() => import("views/CreditVidya"));
const Hdfc = React.lazy(() => import("views/Hdfc"));
const KotakPl = React.lazy(() => import("views/KotakPl"));
const HdfcPl = React.lazy(() => import("views/HdfcPl"));
const Hsbc = React.lazy(() => import("views/Hsbc"));
const Idfc = React.lazy(() => import("views/Idfc"));
const IndiamartBl = React.lazy(() => import("views/IndiamartBl"));
const IndiamartLAP = React.lazy(() => import("views/IndiamartLAP"));
const Indusind = React.lazy(() => import("views/Indusind"));
const IndusB2b = React.lazy(() => import("views/IndusindB2B"));
const KreditBee = React.lazy(() => import("views/KreditBee"));
const LendingKart = React.lazy(() => import("views/LendingKart"));
const LnT = React.lazy(() => import("views/LnT"));
const MoneyView = React.lazy(() => import("views/MoneyView"));
const OroGoldLoan = React.lazy(() => import("views/OroGoldLoan"));
const Paysense = React.lazy(() => import("views/Paysense"));
const Sbi = React.lazy(() => import("views/Sbi"));
const Yes = React.lazy(() => import("views/Yes"));
const StaticPage = React.lazy(() => import("views/StaticPage"));
const AxisStaticPage = React.lazy(() => import("views/AxisStaticPage"));
const HdfcStaticPage = React.lazy(() => import("views/HdfcStaticPage"));
const LnTStaticPage = React.lazy(() => import("views/LnTStaticPage"));
const SbiB2B = React.lazy(() => import("views/SbiB2B"));
const SbiB2BGeneric = React.lazy(() => import("views/SbiB2BGeneric"));
const Protium = React.lazy(() => import("views/Protium"));
const TataCapital = React.lazy(() => import("views/TataCapital"));
const TataCapitalPl = React.lazy(() => import("views/TataCapitalPl"));
const DbsBank = React.lazy(() => import("views/DbsBank"));
const Iifl = React.lazy(() => import("views/Iifl"));
const HealthAssure = React.lazy(() => import("views/HealthAssure"));
const Rupicard = React.lazy(() => import("views/Rupicard"));
const Abfl = React.lazy(() => import("views/Abfl"));
const AbflPl = React.lazy(() => import("views/AbflPl"));
const MoneyTap = React.lazy(() => import("views/MoneyTap"));
const Rupeek = React.lazy(() => import("views/Rupeek"));
const SecuredCCStaticPage = React.lazy(() => import("views/SecuredCC"));
const IdfcFirst = React.lazy(() => import("views/IdfcFirst"));
const IdfcFirstPl = React.lazy(() => import("views/IdfcFirstPl"));
const BimaMantra = React.lazy(() => import("views/BimaMantra"));
const EquitasPl = React.lazy(() => import("views/Equitas"));
const Poonawalla = React.lazy(() => import("views/Poonawalla"));
const TataNeu = React.lazy(() => import("views/TataNeu"));
const HdfcPlJourney = React.lazy(() => import("views/HdfcPlJourney"));
const UnityPl = React.lazy(() => import("views/UnityPl"));
const SmfgPl = React.lazy(() => import("views/SmfgPl"));
const YesBank = React.lazy(() => import("views/YesBank"));
const KotakCC = React.lazy(() => import("views/KotakCC"));
const AmexCC = React.lazy(() => import("views/AmexCC"));
const Hsbccc = React.lazy(() => import("views/Hsbccc"));
const Aspire = React.lazy(() => import("views/Aspire"));
const IciciCc = React.lazy(() => import("views/IciciCc"));
const JioLap = React.lazy(() => import("views/JioLap"));
const FibeLas = React.lazy(() => import("views/FibeLas"));
const CareHealthInsurance = React.lazy(() =>
  import("views/CareHealthInsurance"),
);
const KiwiCC = React.lazy(() => import("views/Kiwi"));
const FiMoney = React.lazy(() => import("views/FiMoney"));
const HeroFin = React.lazy(() => import("views/HeroFin"));
const Bobcard = React.lazy(() => import("views/Bobcard"));
const Scapia = React.lazy(() => import("views/Scapia"));
const Zype = React.lazy(() => import("views/Zype"));
const Federal = React.lazy(() => import("views/Federal"));
const RamFincorp = React.lazy(() => import("views/RamFincorp"));
const SibPl = React.lazy(() => import("views/SibPl"));
const KiwiUpi = React.lazy(() => import("views/kiwiUpi"));
const BobCards = React.lazy(() => import("views/BobCards"));
const Ionic = React.lazy(() => import("views/Ionic"));
const Magnifi = React.lazy(() => import("views/Magnifi"));

const GetPage = ({ type }) => {
  switch (true) {
    case type === "citi-bank" ||
      type === "citibank-creditcard.mymoneymantra.com":
      return (
        <div id="citiBank">
          <CitiBank />
        </div>
      );
    case type === "fibe-bank" || type === "fibepl.mymoneymantra.com":
      return (
        <div id="fibeBank">
          <FibeBank />
        </div>
      );
    case type === "smart-world" || type === "smartuworld.mymoneymantra.com":
      return (
        <div id="smartWorld">
          <SmartWorld />
        </div>
      );

    case type === "profusion" || type === "profusion.mymoneymantra.com":
      return (
        <div id="profusion">
          <Profusion />
        </div>
      );

    case type === "hdfc-credila" || type === "hdfccredila.mymoneymantra.com":
      return (
        <div id="Hdfc-Credila">
          <HdfcCredila />
        </div>
      );

    case type === "hsbc-pl" || type === "hsbcpl.mymoneymantra.com":
      return (
        <div id="hsbcpl">
          <HsbcPl />
        </div>
      );

    case type === "zet-magnet" || type === "magnetcard.mymoneymantra.com":
      return (
        <div id="zet-magnet">
          <ZetMagnet />
        </div>
      );

    case type === "jupiter-cards" || type === "jupitercc.mymoneymantra.com":
      return (
        <div id="jupiterCards">
          <JupiterCards />
        </div>
      );

    case type === "lic-axis-cards" || type === "licaxiscc.mymoneymantra.com":
      return (
        <div id="lic-axis-cards">
          <LICAxisCrards />
        </div>
      );

    case type === "kreditbee" || type === "kreditbee.mymoneymantra.com":
      return (
        <div id="kreditBee">
          <KreditBee />
        </div>
      );

    case type === "incred-pl" || type === "incredpl.mymoneymantra.com":
      return (
        <div id="incred-pl">
          <IncredPl />
        </div>
      );

    case type === "hlbt" || type === "hlbt.mymoneymantra.com":
      return (
        <div id="hlbt">
          <Hlbt />
        </div>
      );
    case type === "propelld" || type === "propelld.mymoneymantra.com":
      return (
        <div id="propelld">
          <Propelld />
        </div>
      );

    case type === "cashe" || type === "cashepl.mymoneymantra.com":
      return (
        <div id="cashe">
          <Cashe />
        </div>
      );

    case type === "fifty-fin" || type === "50fin.mymoneymantra.com":
      return (
        <div id="fifty-fin">
          <FiftyFin />
        </div>
      );

    case type === "early-salary" || type === "stpl.mymoneymantra.com":
      ``;
      return (
        <div id="cashe-earlySalary">
          <CasheEarlySalary />
        </div>
      );
    case type === "abfl-pl" || type === "abflpl.mymoneymantra.com":
      return (
        <div id="abfl-pl">
          <AbflPl />
        </div>
      );

    case type === "axis-cc" || type === "axiscc.mymoneymantra.com":
      return (
        <div id="axisBank">
          <AxisBank />
        </div>
      );

    case type === "axis-cc-new" || type === "axisccnew.mymoneymantra.com":
      return (
        <div id="axisBank">
          <AxisBankNew />
        </div>
      );

    case type === "axis-credit-card" || type === "axis-card.mymoneymantra.com":
      return (
        <div id="axisCc">
          <AxisCC />
        </div>
      );
    case type === "money-view" || type === "moneyview.mymoneymantra.com":
      return (
        <div id="moneyview">
          <MoneyView />
        </div>
      );
    case type === "credit-vidya" || type === "creditvidya.mymoneymantra.com":
      return (
        <div id="creditVidya">
          <CreditVidya />
        </div>
      );

    case type === "idfc" || type === "idfc-cc.mymoneymantra.com":
      return (
        <div id="idfc">
          <Idfc />
        </div>
      );
    case type === "lending-kart" || type === "lendingkart.mymoneymantra.com":
      return (
        <div id="lending-kart">
          <LendingKart />
        </div>
      );
    case type === "paysense" || type === "paysense.mymoneymantra.com":
      return (
        <div id="paysense">
          <Paysense />
        </div>
      );
    case type === "paysense-pl" || type === "paysensepl.mymoneymantra.com":
      return (
        <div id="paysense">
          <Paysense />
        </div>
      );
    case type === "lnt" || type === "ltfs-pl.mymoneymantra.com":
      return (
        <div id="lnt">
          <LnT />
        </div>
      );
    case type === "sbi" || type === "sbicc.mymoneymantra.com":
      return (
        <div id="sbi">
          <Sbi />
        </div>
      );

    case type === "sbib2b" || type === "sbicard.mymoneymantra.com":
      return (
        <div id="sbib2b">
          <SbiB2BGeneric />
        </div>
      );

    case type === "hsbc" || type === "hsbc-creditcard.mymoneymantra.com":
      return (
        <div id="hsbc">
          <Hsbc />
        </div>
      );
    case type === "credit-card" || type === "credit-card.mymoneymantra.com":
      return (
        <div id="credit-card">
          <CreditCard />
        </div>
      );
    case type === "cashkaro" || type === "cashkaro.mymoneymantra.com ":
      return (
        <div id="credit-card">
          <CashKaro />
        </div>
      );
    case type === "privo" || type === "privo.mymoneymantra.com":
      return (
        <div id="privo">
          <Privo />
        </div>
      );

    case type === "rupicard" || type === "rupicard.mymoneymantra.com":
      return (
        <div id="rupicard">
          <Rupicard />
        </div>
      );

    case type === "au" || type === "aucc.mymoneymantra.com":
      return (
        <div id="au">
          <Au />
        </div>
      );
    case type === "hdfc" || type === "hdfccc.mymoneymantra.com":
      return (
        <div id="hdfc">
          <Hdfc />
        </div>
      );
    case type === "yes" || type === "yescc.mymoneymantra.com":
      return (
        <div id="yes">
          <Yes />
        </div>
      );
    case type === "yes-bank" || type === "popcard.mymoneymantra.com":
      return (
        <div id="yes-bank">
          <YesBank />
        </div>
      );
    case type === "induscc" || type === "induscc.mymoneymantra.com":
      return (
        <div id="induscc">
          <Indusind />
        </div>
      );
    case type === "indusb2b" || type === "ccindus.mymoneymantra.com":
      return (
        <div id="indusb2b">
          <IndusB2b />
        </div>
      );
    case type === "kotakcc" || type === "kotakcc.mymoneymantra.com":
      return (
        <div id="kotakcc">
          <KotakCC />
        </div>
      );
    case type === "amexcc" || type === "amexcc.mymoneymantra.com":
      return (
        <div id="amexcc">
          <AmexCC />
        </div>
      );
    case type === "bajaj-rbl" || type === "bajajdbs.mymoneymantra.com":
      return (
        <div id="bajaj-rbl">
          <BajajRbl />
        </div>
      );

    case type === "oro-gold-loan" || type === "oromoney.mymoneymantra.com":
      return (
        <div id="oro-gold-loan">
          <OroGoldLoan />
        </div>
      );
    case type === "kotak-pl" || type === "kotakpl.mymoneymantra.com":
      return (
        <div id="kotak-pl">
          <KotakPl />
        </div>
      );
    case type === "hdfc-pl" || type === "hdfcpl.mymoneymantra.com":
      return (
        <div id="hdfc-pl">
          <HdfcPl />
        </div>
      );
    case type === "indiamart-bl" || type === "indiamartbl.mymoneymantra.com":
      return (
        <div id="indiamart-bl">
          <IndiamartBl />
        </div>
      );

    case type === "indiamart-lap" || type === "indiamartlap.mymoneymantra.com":
      return (
        <div id="indiamart-lap">
          <IndiamartLAP />
        </div>
      );

    case type === "best-credit-cards" ||
      type === "bestcreditcards.mymoneymantra.com":
      return (
        <div id="best-credit-cards">
          <StaticPage />
        </div>
      );
    case type === "prefer-static" || type === "prefr.mymoneymantra.com":
      return (
        <div id="prefer-static">
          <PreferStatic />
        </div>
      );

    case type === "axis-static-page" || type === "best-cards.mymoneymantra.com":
      return (
        <div id="static-pages">
          <AxisStaticPage />
        </div>
      );

    case type === "sbi-static-page" ||
      type === "applycreditcard.mymoneymantra.com":
      return (
        <div id="sbi-static-page">
          <SbiStaticPage />
        </div>
      );

    case type === "hdfc-static-page" ||
      type === "best-credit-cards.mymoneymantra.com":
      return (
        <div id="static-pages">
          <HdfcStaticPage />
        </div>
      );

    case type === "lnt-static-page" || type === "ltfs.mymoneymantra.com":
      return (
        <div id="static-pages">
          <LnTStaticPage />
        </div>
      );

    case type === "protium" || type === "protium.mymoneymantra.com":
      return (
        <div id="protium">
          <Protium />
        </div>
      );
    case type === "tatacapital" || type === "tatacapitalbl.mymoneymantra.com":
      return (
        <div id="tatacapital">
          <TataCapital />
        </div>
      );
    case type === "kissht" || type === "kisshtpl.mymoneymantra.com":
      return (
        <div id="kissht">
          <Kissht />
        </div>
      );
    case type === "tatacapital-pl" ||
      type === "tatacapitalpl.mymoneymantra.com":
      return (
        <div id="tatacapitalpl">
          <TataCapitalPl />
        </div>
      );
    case type === "dbs" || type === "dbs.mymoneymantra.com":
      return (
        <div id="dbs">
          <DbsBank />
        </div>
      );
    case type === "iifl" || type === "iifl.mymoneymantra.com":
      return (
        <div id="iifl">
          <Iifl />
        </div>
      );

    case type === "health-assure" || type === "healthassure.mymoneymantra.com":
      return (
        <div id="health-assure">
          <HealthAssure />
        </div>
      );

    case type === "smart-coin" || type === "smartcoin.mymoneymantra.com":
      return (
        <div id="smart-coin">
          <SmartCoin />
        </div>
      );

    case type === "abfl" || type === "abflbl.mymoneymantra.com":
      return (
        <div id="abfl">
          <Abfl />
        </div>
      );

    case type === "rupeek" || type === "rupeek.mymoneymantra.com":
      return (
        <div id="rupeek">
          <Rupeek />
        </div>
      );
    case type === "axis-credit" || type === "axis-cards.mymoneymantra.com":
      return (
        <div id="axis-credit">
          <AxisCredit />
        </div>
      );
    case type === "moneytap" || type === "moneytap.mymoneymantra.com":
      return (
        <div id="moneytap">
          <MoneyTap />
        </div>
      );
    case type === "dbsgold" || type === "dbsgl.mymoneymantra.com":
      return (
        <div id="dbsgold">
          <DbsGold />
        </div>
      );
    case type === "secured-card" || type === "secured-card.mymoneymantra.com":
      return (
        <div id="securedcc">
          <SecuredCCStaticPage />
        </div>
      );
    case type === "cc-idfc" || type === "cc-idfc.mymoneymantra.com":
      return (
        <div id="idfc-first">
          <IdfcFirst />
        </div>
      );
    case type === "idfc-first-pl" || type === "idfcfirstpl.mymoneymantra.com":
      return (
        <div id="idfc-first-pl">
          <IdfcFirstPl />
        </div>
      );
    case type === "bima-mantra" || type === "lead.mybimamantra.com":
      return (
        <div id="bima-mantra">
          <BimaMantra />
        </div>
      );
    case type === "equitas-pl" || type === "equitaspl.mymoneymantra.com":
      return (
        <div id="equitas-pl">
          <EquitasPl />
        </div>
      );
    case type === "poonawalla" || type === "poonawalla.mymoneymantra.com":
      return (
        <div id="poonawalla">
          <Poonawalla />
        </div>
      );
    case type === "aspire" || type === "aspirebl.mymoneymantra.com":
      return (
        <div id="aspire">
          <Aspire />
        </div>
      );
    case type === "tata-neu" || type === "tataneu.mymoneymantra.com":
      return (
        <div id="tata-neu">
          <TataNeu />
        </div>
      );
    case type === "hdfc-pl-journey" || type === "plhdfc.mymoneymantra.com":
      return (
        <div id="hdfc-pl-journey">
          <HdfcPlJourney />
        </div>
      );
    case type === "unity-pl" || type === "unitypl.mymoneymantra.com":
      return (
        <div id="unity-pl">
          <UnityPl />
        </div>
      );
    case type === "smfg-pl" || type === "smfgpl.mymoneymantra.com":
      return (
        <div id="smfg-pl">
          <SmfgPl />
        </div>
      );
    case type === "hsbccc" || type === "hsbccc.mymoneymantra.com":
      return (
        <div id="hsbccc">
          <Hsbccc />
        </div>
      );
    case type === "icici-cc" || type === "icicicc.mymoneymantra.com":
      return (
        <div id="icici-cc">
          <IciciCc />
        </div>
      );
    case type === "hdfc-personal-loans" || type === "hdfc-pl.mymoneymantra.com":
      return (
        <div id="hdfc-personal-loans">
          <HdfcPersonalLoans />
        </div>
      );
    case type === "jiolap" || type === "jiolap.mymoneymantra.com":
      return (
        <div id="jiolap">
          <JioLap />
        </div>
      );

    case type === "fibelas" || type === "fibelas.mymoneymantra.com":
      return (
        <div id="fibelas">
          <FibeLas />
        </div>
      );

    case type === "care-health-insurance" || type === "care.mymoneymantra.com":
      return (
        <div id="care-health-insurance">
          <CareHealthInsurance />
        </div>
      );
    case type === "kiwi-cc" || type === "kiwi.mymoneymantra.com":
      return (
        <div id="kiwi-cc">
          <KiwiCC />
        </div>
      );
    case type === "fimoney" || type === "fimoney.mymoneymantra.com":
      return (
        <div id="fimoney">
          <FiMoney />
        </div>
      );
    case type === "herofin" || type === "herofin.mymoneymantra.com":
      return (
        <div id="herofin">
          <HeroFin />
        </div>
      );
    case type === "bobcard" || type === "bobcard.mymoneymantra.com":
      return (
        <div id="bobcard">
          <Bobcard />
        </div>
      );
    case type === "federal" || type === "federalcc.mymoneymantra.com":
      return (
        <div id="federal">
          <Federal />
        </div>
      );
    case type === "ram-fincorp" || type === "ramfin.mymoneymantra.com":
      return (
        <div id="ram-fincorp">
          <RamFincorp />
        </div>
      );
    case type === "scapia" || type === "scapia.mymoneymantra.com":
      return (
        <div id="scapia">
          <Scapia />
        </div>
      );
    case type === "zype" || type === "zype.mymoneymantra.com":
      return (
        <div id="zype">
          <Zype />
        </div>
      );
    case type === "kiwi-upi" || type === "kiwicards.mymoneymantra.com":
      return (
        <div id="kiwi-upi">
          <KiwiUpi />
        </div>
      );

    case type === "sib-pl" || type === "sib.mymoneymantra.com":
      return (
        <div id="sibPl">
          <SibPl />
        </div>
      );
    case type === "bob-cc" || type === "bobcards.mymoneymantra.com":
      return (
        <div id="bob-cards">
          <BobCards />
        </div>
      );
    case type === "magnifi" || type === "magnifi.mymoneymantra.com":
      return (
        <div id="magnifi">
          <Magnifi />
        </div>
      );

    case type === "ionic" || type === "ionic.mymoneymantra.com":
      return (
        <div id="ionic">
          <Ionic />
        </div>
      );

    case type === "dmi" || type === "dmi.mymoneymantra.com":
      return (
        <div id="dmi">
          <DMI />
        </div>
      );      
      
    case type === "muthoot-finance" || type === "muthoot.mymoneymantra.com":
      return (
        <div id="muthoot-finance">
          <MuthootFinance />
        </div>
      );

    case type === "getting":
      return <></>;

    default:
      return <h1>404 Page Not Found</h1>;
  }
};

const DomainWrapper = () => {
  const [searchParams] = useSearchParams();
  const [type, setType] = useState("getting");
  const { hostname } = window.location;

  useEffect(() => {
    getType();
  }, []);

  const getType = () => {
    const typeData = window.sessionStorage.getItem("domain");
    setType(() => {
      var res = null;
      if (searchParams.get("domain") !== null) {
        // If URL param domain is present override type
        res = searchParams.get("domain");
      } else if (typeData) {
        // If URL param not present get from session storage
        res = typeData;
      } else {
        // Use hostname
        res = hostname;
      }
      window.sessionStorage.setItem("domain", res);
      return res;
    });
  };

  return <GetPage type={type} />;
};

export default DomainWrapper;
